import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import TrackPurchase from '@reverbdotcom/commons/src/components/track_purchase';
import CreditCardWalletModal from '../components/credit_card_wallet_modal';
import CreditCardWalletIndex from '../components/credit_card_wallet_index';
import CreditCardWalletCreateFormLayout from '../components/credit_card_wallet_create_form_layout';
import CreditCardWalletEditFormLayout from '../components/credit_card_wallet_edit_form_layout';

const CHECKOUT_CONFIRMATION_URI = 'multi-checkout/:order_bundle_id/confirmation';
const CART_NO_OP_URI = 'cart/*';

export const CheckoutRoutes = [
  <Route
    key="cart"
    path="cart"
    lazy={async () => ({
      Component: (await import(
        /* webpackChunkName: 'checkout' */
        '../components/cart/CartLayout'
      )).CartLayout,
    })}
  />,
  <Route
    key="checkout/:id/redirect-return"
    path="checkout/:id/redirect-return"
    lazy={async () => ({
      Component: (await import(
        /* webpackChunkName: 'checkout' */
        '../components/checkout/CheckoutRedirectReturnLayout'
      )).default,
    })}
  />,
  <Route
    key="checkout/:id/payment-in-progress"
    path="checkout/:id/payment-in-progress"
    lazy={async () => ({
      Component: (await import(
        /* webpackChunkName: 'checkout' */
        '../components/checkout/CheckoutPaymentInProgressLayout'
      )).default,
    })}
  />,
  <Route
    key="checkout/:id"
    path="checkout/:id"
    handle={{ clientSide: true }}
    lazy={async () => ({
      Component: (await import(
        /* webpackChunkName: 'checkout' */
        '../components/checkout/CheckoutLayout'
      )).CheckoutLayout,
    })}
  >
    <Route
      key="checkout/:id/cards"
      path="cards"
      Component={CreditCardWalletModal}
      handle={{ clientSide: true }}
    >
      <Route
        key="checkout/:id/cards/index"
        index
        Component={CreditCardWalletIndex}
        handle={{ clientSide: true }}
      />
      <Route
        key="checkout/:id/cards/new"
        path="new"
        Component={CreditCardWalletCreateFormLayout}
        handle={{ clientSide: true }}
      />
      <Route
        key="checkout/:id/cards/:creditCardId/edit"
        path=":creditCardId/edit"
        Component={CreditCardWalletEditFormLayout}
        handle={{ clientSide: true }}
      />
    </Route>
  </Route>,
  <Route
    key="checkout/:id/authorization"
    path="checkout/:id/authorization"
    lazy={async () => ({
      Component: (await import(
        /* webpackChunkName: 'checkout' */
        '../components/checkout/CheckoutAuthorizationLayout'
      )).default,
    })}
  />,
];

export const CheckoutAnalyticsRoutes = [
  <Route
    key={CHECKOUT_CONFIRMATION_URI}
    path={CHECKOUT_CONFIRMATION_URI}
    Component={TrackPurchase}
  />,
  <Route
    key={CART_NO_OP_URI}
    path={CART_NO_OP_URI}
  />,
];
